import { render, staticRenderFns } from "./Ateacher.vue?vue&type=template&id=f6516bfa&scoped=true"
import script from "./Ateacher.vue?vue&type=script&lang=js"
export * from "./Ateacher.vue?vue&type=script&lang=js"
import style0 from "./Ateacher.vue?vue&type=style&index=0&id=f6516bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6516bfa",
  null
  
)

export default component.exports